import { type HTMLAttributes } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  bordered?: boolean;
}

export function Card({ bordered, className, children, ...rest }: CardProps) {
  const hasBgOverride = className ? /(?:^|\s)bg-/.test(className) : false;
  const cls = [
    hasBgOverride
      ? "rounded-card p-5 shadow-card"
      : "bg-paper rounded-card p-5 shadow-card",
    bordered ? "border-2 border-sumi/10" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}
